import { Box, HStack } from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router-dom";

const TABS = [
  { label: "Pulpit", value: "/organizator" },
  { label: "Statystyki", value: "/organizator/statystyki" }
];

/** Przełącznik Pulpit / Statystyki — segmentowany, spójny z zakładkami nagłówka. */
export const DashboardTabs: React.FC<{ value: string }> = ({ value }) => {
  const navigate = useNavigate();
  return (
    <HStack spacing="0" bg="rgba(67,0,152,0.05)" borderRadius="13px" p="4px" w="fit-content">
      {TABS.map(t => {
        const active = t.value === value;
        return (
          <Box
            as="button"
            key={t.value}
            onClick={() => navigate(t.value)}
            px={{ base: "18px", md: "24px" }}
            py="9px"
            borderRadius="10px"
            fontSize="14px"
            fontWeight="700"
            whiteSpace="nowrap"
            bg={active ? "white" : "transparent"}
            color={active ? "primary" : "gray.500"}
            boxShadow={active ? "0 2px 8px rgba(67,0,152,0.12)" : "none"}
            transition="all 0.15s"
            _hover={active ? {} : { color: "primary" }}
          >
            {t.label}
          </Box>
        );
      })}
    </HStack>
  );
};
